import React, { useState, useEffect, useContext, lazy, Suspense } from "react";
import auth from "services/auth";
import { isPWA as isPWAMode } from "utils/isPWA";
import { Redirect, Route, Link, useLocation } from "react-router-dom";
// import Header from "elements/Header";
import Footer from "elements/Footer";
import LoginBonus from "elements/LoginBonus";
import ls from "services/ls";
import AppContext from "contexts/AppContext";
import api from "services/api";
import Swal from "sweetalert2";
import Translator, { __ } from "services/Translator";
import Sidebar from "components/Sidebar";

import {
  isMobile,
  isMobileByViewPort,
  cauculateLandScape,
} from "services/isMobile";
// import { useIdleTimer } from "react-idle-timer";

// import SuppotrSideBar from "elements/SuppotrSideBar";
import IdleActivity from "elements/IdleActivity";

//Updated structure start's here
import RightSidebarShortLong from "components/RightSidebarShortLong";
import StickyFooterMenu from "components/StickyFooterMenu";
import CashierModals from "components/CashierModals";
import CashierRedesign from "components/cashier-redesign/CashierRedesign";
import GeoRestriction from "elements/GeoRestriction";
import ScrollToTop from "elements/ScrollToTop";
import Loader from "components/Loader";
import Header from "components/Header";
import LoginReg, { loginData } from "components/LoginReg";
import LiveChat from "elements/LiveChat";
import TugiWidget from "elements/TugiWidget";
import { useSelector, useDispatch } from "react-redux";
import { updateUserBalance } from "stores/balance/userBalance";
import ExitIntentPopup from "components/ExitIntentPopup";
import Play365GlobalBackground from "components/Play365GlobalBackground";
import ProfileCompleteModal from "components/ProfileCompleteModal";
import { extractProvidersFromResponse, normalizeProviders } from "utils/providers";
import { isProfileComplete } from "utils/profileValidation";
import {
  setAccountCountry,
  getAccountCountry,
  clearAccountCountry,
  getManualCountry,
  setManualCountry,
  notifyCountryChanged,
  resolveGeoCountry,
} from "services/requestCountry";
import { fetchCategories } from "services/categories";
import useCountryRefetch from "hooks/useCountryRefetch";
// SplashScreen is imported eagerly (not lazy) so it is present in FullLayout's
// very first paint and covers the app immediately — preventing a flash of the
// real UI before the splash overlay mounts.
import SplashScreen from "components/SplashScreen";

// PWA-only components are lazy loaded so browser users never download them.
const PWAOnboarding = lazy(() => import("components/PWAOnboarding"));
const PWAHeader = lazy(() => import("components/PWAHeader"));
const StickyFooterMenuPWA = lazy(() => import("components/StickyFooterMenuPWA"));
const PWAInstallPrompt = lazy(() => import("components/PWAInstallPrompt"));

const isPWA = isPWAMode();

const FullLayout = ({ children, ...rest }) => {
  const [openSupportSideBar, setOpenSupportSideBar] = useState();
  const showSupportSidebar = (receiveVal) => {
    setOpenSupportSideBar(receiveVal);
    setTimeout(function () {
      setOpenSupportSideBar(false);
    }, 500);
  };
  const dispatch = useDispatch();

  const [supportSidebarOpen, setSupportSidebarOpen] = useState(false);
  const [showRightSidebar, setShowRightSidebar] = useState(false);
  const [modalSignUpPropsData, setModalSignUpPropsData] = useState(false);
  const [modalLoginPropsData, setModalLoginPropsData] = useState(false);
  const [showProfileCompleteModal, setShowProfileCompleteModal] = useState(false);
  // When the profile modal is opened as a deposit gate (FR-18) it must be
  // completed, not skipped, before the player can proceed to the deposit.
  const [profileGateBlocking, setProfileGateBlocking] = useState(false);

  const [spinner, setSpinner] = useState(false);
  const [dummySpinner, setDummySpinner] = useState(false);

  const location = useLocation();
  const [isLandscape, setIsLandscape] = useState(cauculateLandScape());
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  const [isMobileDeviceByViewPort, setIsMobileDeviceByViewPort] =
    useState(false);
  const [showLeftSidebar, setShowLeftSidebar] = useState(false);

  const showAlert = (title, message, isError, callback) => {
    const normalizedTitle = typeof title === "string" ? title.trim() : "";
    const loweredTitle = normalizedTitle.toLowerCase();
    const sanitizedTitle =
      loweredTitle === "warning" ||
      loweredTitle === "warning!" ||
      loweredTitle === "warning!!"
        ? ""
        : normalizedTitle;

    Swal.fire({
      className: "dark",
      title: sanitizedTitle || undefined,
      text: message,
      timer: 70000, // Set the time duration in milliseconds
      showConfirmButton: true, // Hide the "OK" button
      icon: isError ? undefined : "success",
      customClass: {
        popup: "dark-theme-popup",
        title: "dark-theme-title",
        content: "dark-theme-content",
        confirmButton: "dark-theme-confirm-button",
      },
    });
  };

  const [isAuthenticated, setIsAuthenticated] = useState(
    auth.isAuthenticated()
  );
  const [userDetails, setUserDetails] = useState(auth.getUser);

  //Get user balance functionality

  const { getUserBalance } = useContext(AppContext);

  const [accountProgress, setAccountProgress] = useState(0);
  const getAccountProgress = async (ev) => {
    var response = await api.get("/account-progress");
    // console.log("accountProgress", response);
    setAccountProgress(response.data);
  };

  const [notificationCount, setNotifictionCount] = useState(0);
  const getNotificationsCount = async (ev) => {
    var response = await api.get("/player/messages-and-notifications-count");
    if (response.status === 200) {
      setNotifictionCount(response.data);
    }
  };

  const checkProfileCompleteness = async () => {
    if (!auth.isAuthenticated()) return;
    const previousAccount = getAccountCountry();
    let profile = null;
    try {
      const response = await api.get("/profile");
      if (response.status === 200 && response.data) {
        profile = response.data;
      }
    } catch (_) {
      // Swallowed on purpose, but the scope-lock reconciliation below still runs.
    }

    if (profile) {
      // Account-tier country for per-country content (sits below the manual
      // selector, above geo-IP). Field is camelCase `playerCountry`.
      setAccountCountry(profile.playerCountry);
    }

    // A logged-in player's scope is locked to their account country, so drop any
    // manual pick left over from browsing logged-out — otherwise the flag, the
    // game feed and the per-country banners/promotions disagree. This must run
    // even when /profile failed, timed out or omitted playerCountry: the locked
    // header indicator has already moved to the account country, so a surviving
    // stale manual pick is exactly the header-vs-banners desync this clear
    // exists to prevent. Both branches stay idempotent — the manual clear is
    // self-clearing and the notify only fires when the account country actually
    // changed — so the repeated /profile polls cost no extra refetches.
    if (getManualCountry()) {
      setManualCountry(""); // fires COUNTRY_CHANGED_EVENT -> indicator + content refetch
    } else if (getAccountCountry() !== previousAccount) {
      // setAccountCountry fires nothing; without this the indicator would stay
      // on geo until some other country event happened to wake it.
      notifyCountryChanged();
    }

    if (profile) {
      if (!isProfileComplete(profile)) {
        setShowProfileCompleteModal(true);
      } else {
        setShowProfileCompleteModal(false);
      }
    }
  };

  useEffect(() => {
    // alert(window.innerWidth);
    const handleResize = () => {
      setIsLandscape(cauculateLandScape());
      const currentIsMobile = isMobile();
      const currentIsMobileByViewPort = isMobileByViewPort();

      setIsMobileDevice(currentIsMobile);
      setIsMobileDeviceByViewPort(currentIsMobileByViewPort);

      // Auto-collapse sidebar on mobile devices and tablets (< 1200px)
      if (currentIsMobile || currentIsMobileByViewPort || window.innerWidth < 1200) {
        setIsSidebarCollapsed(true);
      }

      if (!currentIsMobile && window.innerWidth > 1200) {
        setShowLeftSidebar(false);
      }
    };

    if (!isMobile() || !isMobileByViewPort()) {
      window.addEventListener("resize", handleResize);

      // Initial setup
      handleResize();
    }

    var interval;
    if (isAuthenticated) {
      getAccountProgress();
      getUserBalance();
      setUserDetails(auth.getUser());
      getNotificationsCount();
      checkProfileCompleteness();
    }

    interval = setInterval(() => {
      if (isAuthenticated) {
        getUserBalance();
        getNotificationsCount();
      }
    }, 10000);
    return () => {
      try {
        clearInterval(interval);
        window.removeEventListener("resize", handleResize);
      } catch (ex) {}
    };
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      checkProfileCompleteness();
    }
  }, [isAuthenticated]);

  // Deposit gate (FR-18): the Cashier fires "profile-gate-required" when a
  // deposit is attempted with an incomplete profile; open the modal in a
  // non-skippable mode so billing identity is captured before the deposit.
  useEffect(() => {
    const openProfileGate = () => {
      setProfileGateBlocking(true);
      setShowProfileCompleteModal(true);
    };
    window.addEventListener("profile-gate-required", openProfileGate);
    return () => window.removeEventListener("profile-gate-required", openProfileGate);
  }, []);

  const reduxIsAuthenticated = useSelector((state) => state.userAuth.isAuthenticated);

  useEffect(() => {
    // Keep the local auth flag in sync with the store in BOTH directions.
    // Previously it only synced to true, so when the user became logged out
    // (e.g. token expiry) the PWA header stayed visible and the onboarding
    // overlay never re-appeared, leaking the Landing page underneath.
    setIsAuthenticated(reduxIsAuthenticated);
    if (reduxIsAuthenticated) {
      checkProfileCompleteness();
    } else {
      // Logged out (incl. token expiry): drop the account-tier country so the
      // next visitor falls back to geo-IP for per-country content.
      clearAccountCountry();
    }
  }, [reduxIsAuthenticated]);

  useEffect(() => {
    setDummySpinner(true);
    setTimeout(() => {
      setDummySpinner(false);
    }, 500);
  }, [location.pathname]);

  const [displayedModal, setDisplayedModal] = useState(null);

  const [breadcrumb, setBreadcrumb] = useState([]);

  const setUsersWallet = async (currency) => {
    var response = await api.post("/set-wallet", { currency });
    // console.log(response);
    if (response.status === 200) {
      dispatch(updateUserBalance(response.data));
      ls.set("conversionRates", response.data.rates);
    }
  };

  const [openWalletModalTab, setOpenWalletModalTab] = useState(null);
  const [showBuyModalG, setShowBuyModalG] = useState(false);

  // GCC-gated cashier redesign flag from /initial-settings. Defaults false, so
  // absent/false keeps the existing CashierModals cashier unchanged.
  const [cashierRedesignEnabled, setCashierRedesignEnabled] = useState(false);
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const response = await api.get("/initial-settings");
        if (alive && response.status === 200) {
          setCashierRedesignEnabled(
            !!(response.data && response.data.cashier_redesign_enabled)
          );
        }
      } catch (e) {}
    })();
    return () => {
      alive = false;
    };
  }, []);
  const cashierRedesignOpen =
    openWalletModalTab === "deposit" || openWalletModalTab === "withdraw";

  const [searchStr, setSearchStr] = useState(""); //Used in Header.js and Games.js
  const [providers, setProviders] = useState([]); //Used in Header.js and Games.js
  const [providersLoading, setProvidersLoading] = useState(false);
  const [sortStr, setSortStr] = useState(null); //Used in Header.js and Games.js
  const [selectedProviders, setSelectedProviders] = useState([]); //Used in Header.js and Games.js
  const getProviders = async () => {
    try {
      setProvidersLoading(true);
      var response = await api.get("/games/providers");
      if (response.status === 200) {
        const list = extractProvidersFromResponse(response.data);
        setProviders(normalizeProviders(list));
      } else {
        setProviders([]);
      }
    } finally {
      setProvidersLoading(false);
    }
  };
  useEffect(() => {
    getProviders();
  }, []);

  // Category navigation from the API (per-scope labels/visibility/order);
  // null keeps every consumer on its hardcoded fallback, identical to
  // today. resolveGeoCountry first (idempotent, ls-cached) so the very
  // first fetch already carries X-Request-Country.
  const [categories, setCategories] = useState(null);
  // Bumps on a country switch so the per-scope category menu (order/visibility)
  // refetches in place, matching the game grids — without this the menu keeps the
  // country it was first loaded with until a full page reload.
  const countryNonce = useCountryRefetch();
  const getCategories = async () => {
    try {
      await resolveGeoCountry(api);
    } catch (error) {
      // country stays unknown; the fetch proceeds scope-less
    }
    setCategories(await fetchCategories(api));
  };
  useEffect(() => {
    getCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countryNonce]);

  const [categoryName, setCategoryName] = useState("All Games");
  //updated structure
  const [isChatVisible, setIsChatVisible] = useState(false);
  const [animationStarts, setAnimationStarts] = useState(false);

  // Auto-collapse sidebar on tablet and mobile (< 1200px)
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
    return window.innerWidth < 1200;
  });
  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };
  const passableParams = {
    categories,
    showAlert,
    isMobileDevice,
    isMobileDeviceByViewPort,
    isLandscape,
    isAuthenticated,
    setIsAuthenticated,
    setSpinner,
    userDetails,
    notificationCount,
    accountProgress,
    getAccountProgress,
    displayedModal,
    setDisplayedModal,
    breadcrumb,
    setBreadcrumb,
    setUsersWallet,
    openWalletModalTab,
    setOpenWalletModalTab,
    searchStr,
    setSearchStr,
    providers,
    providersLoading,
    setProviders,
    selectedProviders,
    sortStr,
    setSortStr,
    setSelectedProviders,
    getProviders,
    showLeftSidebar,
    setShowLeftSidebar,
    setCategoryName,
    categoryName,
    modalSignUpPropsData,
    setModalSignUpPropsData,
    modalLoginPropsData,
    setModalLoginPropsData,
    showRightSidebar,
    setShowRightSidebar,
    supportSidebarOpen,
    setSupportSidebarOpen,
    isChatVisible,
    setIsChatVisible,
    setShowBuyModalG,
    showBuyModalG,
    isSidebarCollapsed,
    setIsSidebarCollapsed,
    checkProfileCompleteness,
    onRequestProfileComplete: checkProfileCompleteness,
    cashierRedesignEnabled,
  };

  const childrenWithProps = React.Children.map(children, (child) => {
    // Checking isValidElement is the safe way and avoids a typescript
    // error too.
    if (React.isValidElement(child)) {
      return React.cloneElement(child, passableParams);
    }
    return child;
  });

  const [inPlay, setInPlay] = useState(false);
  const playPath = location.pathname.split("/");

  useEffect(() => {
    setInPlay(playPath.includes("play"));
    setIsMobileDevice(isMobile());
  }, [playPath]);

  useEffect(() => {
    if (!isMobileDevice && window.innerWidth >= 1200) {
      document.body.classList.toggle("sidebar-collapsed", isSidebarCollapsed);
    } else {
      document.body.classList.remove("sidebar-collapsed");
    }
    return () => document.body.classList.remove("sidebar-collapsed");
  }, [isSidebarCollapsed, isMobileDevice]);

  return (
    <>
      {spinner && <Loader />}
      {isPWA && <SplashScreen />}
      {isPWA && !isAuthenticated && (
        <Suspense fallback={null}>
          <PWAOnboarding {...passableParams} />
        </Suspense>
      )}
      {!isPWA && (
        <Suspense fallback={null}>
          <PWAInstallPrompt />
        </Suspense>
      )}
      <LoginReg {...passableParams} />
      <ProfileCompleteModal
        show={showProfileCompleteModal}
        blocking={profileGateBlocking}
        onHide={() => {
          setShowProfileCompleteModal(false);
          setProfileGateBlocking(false);
        }}
        setSpinner={setSpinner}
        getAccountProgress={getAccountProgress}
        onCompleted={() => {
          setShowProfileCompleteModal(false);
          setProfileGateBlocking(false);
        }}
      />
      <div className="app-container">
        <Play365GlobalBackground />
        {isPWA ? (
          isAuthenticated && (
            <Suspense fallback={null}>
              <PWAHeader {...passableParams} />
            </Suspense>
          )
        ) : (
          (isMobileDevice && inPlay) || <Header {...passableParams} />
        )}

        <div
          className={
            "mainContainer " +
            (isChatVisible && isAuthenticated ? " chat_open " : "")
          }
        >
          <div className="main-layout-wrapper">
            {/* <LeftSidebarShortLong
              {...passableParams}
              isCollapsed={isSidebarCollapsed}
              toggleSidebar={toggleSidebar}
            /> */}
            
            <Sidebar
              isCollapsed={isSidebarCollapsed}
              toggleSidebar={toggleSidebar}
              {...passableParams}
            />
            <div
              id="mainContent"
              className={
                "mainContent " +
                (passableParams.showLeftSidebar ? " sidebarOpend " : "") +
                `content ${isSidebarCollapsed ? "shifted sidebarCollapsed" : "sidebarNotCollapsed"}` +
                ` ${isMobileDevice ? "mobile" : "desktop"}`
              }
              style={{
                ...(isPWA && isAuthenticated
                  ? { paddingTop: "calc(10px + env(safe-area-inset-top))" }
                  : {}),
                ...(isPWA && isMobileDevice
                  ? { paddingBottom: "calc(70px + env(safe-area-inset-bottom))" }
                  : {}),
              }}
            >
              {/* <Header className={inPlay ? "inplay" : ""} {...passableParams} /> */}
              <main
                className={animationStarts ? " slideUpAnimation ms400" : " "}
              >
                {childrenWithProps}
              </main>
              {!isPWA && ((isMobileDevice && inPlay) || <Footer {...passableParams} />)}
            </div>
          </div>
        </div>
      </div>
      <LiveChat {...passableParams} />
      <TugiWidget isAuthenticated={isAuthenticated} />
      {!isPWA && isMobileDevice && isAuthenticated && inPlay && (
        cashierRedesignEnabled ? (
          <>
            <CashierModals {...passableParams} cashierRedesignEnabled />
            <CashierRedesign
              open={cashierRedesignOpen}
              onClose={() => setOpenWalletModalTab(null)}
              initialTab={openWalletModalTab}
            />
          </>
        ) : (
          <CashierModals {...passableParams} />
        )
      )}
      {isPWA && isAuthenticated && (
        cashierRedesignEnabled ? (
          <>
            <CashierModals modalsOnly={true} {...passableParams} cashierRedesignEnabled />
            <CashierRedesign
              open={cashierRedesignOpen}
              onClose={() => setOpenWalletModalTab(null)}
              initialTab={openWalletModalTab}
            />
          </>
        ) : (
          <CashierModals modalsOnly={true} {...passableParams} />
        )
      )}
      {isMobileDevice &&
        (!inPlay || !isLandscape) &&
        (isPWA ? (
          <Suspense fallback={null}>
            <StickyFooterMenuPWA {...passableParams} />
          </Suspense>
        ) : (
          <StickyFooterMenu {...passableParams} />
        ))}
      <GeoRestriction {...passableParams} />
      <LoginBonus />
      <ScrollToTop />
      <ExitIntentPopup 
        isAuthenticated={isAuthenticated}
        setModalSignUpPropsData={setModalSignUpPropsData}
      />
    </>
  );
};

export default FullLayout;
